import '../scss/document/_index.scss'
import Navigation from './document/navigation.js'
import DocumentInquiry from './document/inquiry.js'
import DocumentSearch from './document/search.js'

const initArticleNavigation = () => {
  document.querySelectorAll('[data-info-article]').forEach((element) => {
    const articleNavigation = new Navigation(element)

    articleNavigation.init()
  })
}

const initPolyestershoppen = () => {
  initArticleNavigation()
  DocumentInquiry.init()
  DocumentSearch.init()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPolyestershoppen, { once: true })
} else {
  initPolyestershoppen()
}
